function omit(object, properties, strict = false) {
  const next = { ...object };
  for (let key of properties) {
    if (key in object) {
      delete next[key];
    } else if (strict) {
      throw new Error(`Key "${String(key)}" does not exist in object ${JSON.stringify(object)}`);
    }
  }
  return next;
}
export {
  omit
};
//# sourceMappingURL=omit.js.map
